import axios from "axios";
import moment from "moment";
import { appInsights } from "shared/utils/helperFunctions/appInsights"; 

import configureStore from "redux/configureStore";

const { persistor } = configureStore();

const subscriptionKey =
  window.jllConfig && window.jllConfig.subscription_token
    ? window.jllConfig.subscription_token
    : process.env.REACT_APP_SUBSCRIPTION_KEY;

const getAccessCheck = () => {
  var accessCheck = window.accessCheck;

  if (!accessCheck) {
    const token = JSON.parse(localStorage.getItem("okta-token-storage"))
      .accessToken?.accessToken;

    accessCheck = {
      auth: {
        getAccessToken: () => {
          return token;
        },
      },
    };
  }

  return accessCheck;
};

export function deleteRequest(url, data) {
  const accessCheck = getAccessCheck();

  return callApi(accessCheck, false, url, data, "DELETE");
}

export function postRequest(url, data, ignoreResponse = false, responseType) {
  const accessCheck = getAccessCheck();

  return callApi(
    accessCheck,
    false,
    url,
    data,
    "POST",
    responseType,
    ignoreResponse
  );
}

export function putRequest(url, data) {
  const accessCheck = getAccessCheck();

  return callApi(accessCheck, false, url, data, "PUT");
}

export function getRequest(url, responseType) {
  const accessCheck = getAccessCheck();

  return callApi(accessCheck, true, url, null, null, responseType);
}

async function callApi(
  accessCheck,
  isGet,
  apiUrl,
  apiData,
  methodType,
  responseType,
  ignoreResponse = false
) {
  let method = "post";
  let data = {};

  if (apiData) {
    data = apiData;
  }

  if (isGet) {
    method = "get";
    data = "";
  }

  if (methodType) {
    method = methodType;
  }

  if (accessCheck?.auth) {
    if (checkAuthentication()) {
      const authenticated = await renewSession(accessCheck.auth);

      if (authenticated) {
        return callRespectiveFunction(
          accessCheck,
          method,
          data,
          apiUrl,
          responseType,
          ignoreResponse
        );
      } else {
        accessCheck.history?.push("/"); // ?? window.location.href = `${window.location.host}`;
        // accessCheck.history.push("/sessionexpired");
      }
    } else {
      return callRespectiveFunction(
        accessCheck,
        method,
        data,
        apiUrl,
        responseType,
        ignoreResponse
      );
    }
  }
}

function callRespectiveFunction(
  accessCheck,
  method,
  data,
  url,
  responseType,
  ignoreResponse
) {
  const token = accessCheck.auth.getAccessToken();

  if (token) {
    return axios({
      method: method,
      url: url,
      crossdomain: true,
      timeout: 600000,
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: `Bearer ${token}`,
        "Subscription-Key": subscriptionKey,
      },
      data: data,
      responseType: responseType !== undefined ? responseType : "json",
    })
      .then((response) => {
        if (response?.headers["x-ui-version"] && response.headers["x-ui-version"] !== localStorage.getItem("ui-version")) {
          console.log("UI Version Mismatch - Reloading");

          localStorage.setItem("ui-version", response.headers["x-ui-version"]);

          persistor.pause();
          persistor.flush().then(() => {
            return persistor.purge();
          }).finally(() => {
            window.location.reload();
          });
        }

        if (
          response.status !== 200 &&
          response.status !== 204 &&
          !ignoreResponse
        ) {
          if (response.status === 401 || response.status === 403) {
            accessCheck.history.push(`/unauthorized`, { status: response.status });
          } else {
            return response;
          }
        } else if (response) {
          return response;
        }
      })
      .catch((ex) => {
        const { response } = ex;
        if (!ignoreResponse) {
          if (
            response &&
            (response.status === 401 || response.status === 403)
          ) {
            accessCheck.history.push(`/unauthorized`);
            appInsights.trackException({ error: ex, response });
          } else {
            
            //accessCheck.history.push(`/error?message=${ex.message}`);
            const exceptionDetails = { error: ex, data };
            appInsights.trackException(exceptionDetails);
          }
        } else {
          console.log("User Analytics Error - " + response);
        }
      });
  } else {
    //accessCheck.history.push(`/error?message='Token Expired'`);
  }
}

async function renewSession(auth) {
  let promise = auth.tokenManager
    .renew("accessToken")
    .then(function (freshToken) {
      let oldtoken = JSON.parse(localStorage.getItem("okta-token-storage"));
      oldtoken.accessToken = freshToken;
      localStorage.setItem("okta-token-storage", JSON.stringify(oldtoken));
      localStorage.setItem("oktaAccessToken", freshToken);

      return true;
    })
    .catch(function (err) {
      localStorage.removeItem("okta-cache-storage");
      localStorage.removeItem("okta-token-storage");
      return false;
    });

  let result = await promise;
  return result;
}

const checkAuthentication = () => {
  const tokenToRenew = JSON.parse(
    localStorage.getItem("okta-token-storage")
  ).accessToken;

  if (
    tokenToRenew &&
    tokenToRenew.expiresAt &&
    moment(moment.utc(moment.unix(tokenToRenew.expiresAt).format())).isBefore(
      moment.utc(moment(new Date()).add(30, "minutes").format())
    )
  ) {
    return true;
  } else {
    return false;
  }
};
